import { NS_ERROR } from '@/i18n/namespaces';
import { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type BaseInputProps = {
  label?: string;
  error?: string;
  required?: boolean;
  optional?: boolean;
  children: ReactNode;
  /**
   * react-hook-form field name. Rendered as `data-error-anchor`
   * so `scrollToFirstError` can locate the wrapper when the
   * underlying control is not a native named input (custom
   * checkboxes, radios, file uploads).
   */
  name?: string;
};

export const BaseInput = ({
  label,
  error,
  required,
  optional,
  children,
  name,
}: BaseInputProps) => {
  return (
    <div className="flex w-full flex-col gap-2" data-error-anchor={name}>
      {label && (
        <span className={twMerge('text-primary', error && 'text-error')}>
          {label}
          {required && (
            <span className="ml-0.5 text-error" aria-hidden="true">
              *
            </span>
          )}
          {optional && (
            <span className="text-sm text-gray-400"> (optional)</span>
          )}
        </span>
      )}

      {children}

      {error && error !== ' ' && (
        <span className="text-xs text-error">
          <Trans ns={NS_ERROR}>{error}</Trans>
        </span>
      )}
    </div>
  );
};
